/**
 * All the legend service types.
 */
export const allLegendServiceTypes = [
  'Tax',
  'Consultation',
  'Bookkeeping',
  'Misc',
] as const

/**
 * The legend service type.
 */
export type LegendServiceType = (typeof allLegendServiceTypes)[number]
